import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import { useState } from "react";
import FormSlipGaji from "../components/FormSlipGaji";
import PreviewSlipGaji from "../components/PreviewSlipGaji";

const SlipGajiContainer = () => {
  const [mode, setMode] = useState("form");
  const [pending, setPending] = useState(false);
  const [dataPreview, setDataPreview] = useState();

  return (
    <FeatureContainer title={mode === "form" ? "Form Slip Gaji" : "Preview"}>
      {mode === "form" && (
        <FormSlipGaji 
          setMode={setMode} 
          setData={setDataPreview} 
          pending={pending} 
          setPending={setPending} 
        />
      )}
      {mode === "preview" && (
        <PreviewSlipGaji 
          data={dataPreview} 
          pending={pending} 
          setMode={setMode}
        />
      )}
    </FeatureContainer>
  );
};

export default SlipGajiContainer;